import { ComponentType, FC, Suspense } from 'react';
import { AuthButtonsDefaultLayoutSkeleton } from './layouts/Default/Skeleton';
import { AuthButtonsFtnftAmLayoutSkeleton } from './layouts/FtnftAm/Skeleton';
import { AuthButtonsKioskLayoutSkeleton } from './layouts/Kiosk/Skeleton';
import * as Styled from './styles';
import { lazy } from 'utils/generic/lazy';
import { Configs } from 'constants/app/configs';
import { ViewModes } from 'interfaces';

const { AuthButtonsDefaultLayout } = lazy(
  () =>
    import(
      /* webpackChunkName: "AuthButtonsDefaultLayout" */ './layouts/Default'
    )
);
const { AuthButtonsFtnftAmLayout } = lazy(
  () =>
    import(
      /* webpackChunkName: "AuthButtonsFtnftAmLayout" */ './layouts/FtnftAm'
    )
);
const { AuthButtonsKioskLayout } = lazy(
  () =>
    import(/* webpackChunkName: "AuthButtonsKioskLayout" */ './layouts/Kiosk')
);

const AUTH_BUTTONS_LAYOUTS: Record<
  ViewModes,
  {
    component: ComponentType;
    skeleton: ComponentType;
  }
> = {
  [ViewModes.DEFAULT]: {
    component: AuthButtonsDefaultLayout,
    skeleton: AuthButtonsDefaultLayoutSkeleton
  },
  [ViewModes.KIOSK]: {
    component: AuthButtonsKioskLayout,
    skeleton: AuthButtonsKioskLayoutSkeleton
  },
  [ViewModes.FTNFT_AM]: {
    component: AuthButtonsFtnftAmLayout,
    skeleton: AuthButtonsFtnftAmLayoutSkeleton
  },
  [ViewModes.KIOSK_AM]: {
    component: AuthButtonsKioskLayout,
    skeleton: AuthButtonsKioskLayoutSkeleton
  },
  [ViewModes.KIOSK_VENICE]: {
    component: AuthButtonsKioskLayout,
    skeleton: AuthButtonsKioskLayoutSkeleton
  }
};

export const AuthButtons: FC = () => {
  const View = AUTH_BUTTONS_LAYOUTS[Configs.VIEW_MODE];

  return (
    <Styled.AuthButtonsWrapper>
      <Suspense fallback={<View.skeleton />}>
        <View.component />
      </Suspense>
    </Styled.AuthButtonsWrapper>
  );
};
